import React, { useState } from 'react';
import ApplicationForm from '../components/ApplicationForm';
import SpecializedPrograms from '../components/SpecializedPrograms';
import CelebratingAchievements from '../components/CelebratingAchievements';
import StudentServices from '../components/StudentServices';
import UniversityEvents from '../components/UniversityEvents';
import FAQ from '../components/FAQ';

const PrivacyPolicy = () => {
  const [showApplicationModal, setShowApplicationModal] = useState(false);

  return (
    <>
      <div className="container mt-5 pt-5">
      <div className="row">
        <div className="col-lg-12">
          <h1 className="text-center mb-5">Privacy Policy & Disclaimer</h1>
          
          <div className="content">
            <h3>Privacy Policy</h3>
            <p>
              Mewar University respects your privacy and is committed to protecting your personal information. 
              This privacy policy explains how we collect, use, and safeguard your information when you visit our website or use our services.
            </p>
            
            <h4>Information We Collect</h4>
            <ul>
              <li>Personal information you provide when filling out forms</li>
              <li>Contact information including name, email, and phone number</li>
              <li>Academic and professional background information</li>
              <li>Website usage data and analytics</li>
            </ul>
            
            <h4>How We Use Your Information</h4>
            <ul>
              <li>To process your applications and inquiries</li>
              <li>To provide educational services and support</li>
              <li>To communicate important updates and information</li>
              <li>To improve our website and services</li>
            </ul>
            
            <h3>Disclaimer</h3>
            <p>
              The information provided on this website is for general information purposes only. 
              While we strive to keep the information up to date and correct, we make no representations 
              or warranties of any kind about the completeness, accuracy, reliability, suitability, or 
              availability of the website or the information contained on the website.
            </p>
            
            <h4>Contact Information</h4>
            <p>
              If you have any questions about this Privacy Policy or Disclaimer, please contact us at:
            </p>
            <p>
              Email: info@distanceengineering.org<br />
              Phone: +91 869 295 6126<br />
              Address: NH - 48 Gangrar, Chittorgarh, Rajasthan - 312901
            </p>
          </div>
        </div>
      </div>
      </div>

      {/* Specialized Programs Section */}
      <SpecializedPrograms setShowApplicationModal={setShowApplicationModal} />

      {/* Celebrating Our Achievements Section */}
      <CelebratingAchievements />

      {/* Student Services Section */}
      <StudentServices />

      {/* University Events Section */}
      <UniversityEvents />

      {/* FAQ Section */}
      <FAQ />

      {/* Application Modal */}
      <ApplicationForm 
        show={showApplicationModal} 
        onHide={() => setShowApplicationModal(false)} 
      />
    </>
  );
};

export default PrivacyPolicy;
